export default {
    SET_USER_REPORTS: (state, reports) => {
        state.userReports = reports;
    },

    SET_CATEGORIES: (state, categories) => {
        state.categories = categories;
    },

    SET_REPORT_CATEGORY: (state, category) => {
        state.filters.reportCategory = category;
    },

    SET_REPORT_ID: (state, reportId) => {
        state.filters.reportId = reportId;
    },

    PROCCESS_RES: (state, data) => {
        state.items = data.items;

        state.pagination = {
            page: data.page || 1,
            totalPages: data.totalPages || 1
        };
    },

    SET_QUERY: (state, query) => {
        state.filters.query = query;
    },

    SET_ALL_REPORTS: (state, allReports) => {
        state.all = allReports;
    }
};
